var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-carousel',{attrs:{"height":_vm.lbHeight + 'px'}},_vm._l((_vm.imgArr),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{staticClass:"bgimgs",attrs:{"src":_vm.$imgUrl + item.bannerImg,"alt":""}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }